import PropTypes from 'prop-types';
import { Card, Typography } from '@mui/material';
import { RISK_COLORS, STATUS_COLORS } from '../../../pages/projects/overview/components/MoreDetails';

export default function AppWidgetSummary({ title, total, status, risk, color = 'primary', sx, ...other }) {
  const derivedColor = (status && STATUS_COLORS[status]) || (risk && RISK_COLORS[risk]) || null;

  return (
    <Card
      sx={{
        py: 1,
        boxShadow: 0,
        textAlign: 'center',

        ...(derivedColor
          ? {
              bgcolor: derivedColor.bg,
              color: derivedColor.text,
            }
          : {
              bgcolor: (theme) => theme.palette[color].lighter,
              color: (theme) => theme.palette[color].darker,
            }),

        ...sx,
      }}
      {...other}
    >
      <Typography variant="h4">{total}</Typography>

      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        {title}
      </Typography>
    </Card>
  );
}

AppWidgetSummary.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.any.isRequired,
  status: PropTypes.string,
  risk: PropTypes.string,
  color: PropTypes.string,
  sx: PropTypes.object,
};
